type Phrases = {
  [key: string]: any;
};

export enum LanguageKey {
  "en-us" = "en-us",
  de = "de",
  es = "es",
  fr = "fr",
  zh = "zh",
}

export type I18n = {
  t: (key?: string, interpolationOptions?: Object) => string;
  extend: (phrases: Phrases) => void;
  currentLocale: LanguageKey;
};
